import request from '@/utils/request'

export function queryRequest(data) {
  return request({
    url: '/db/role/query',
    method: 'post',
    data
  })
}
export function deleteRequest(id) {
  return request({
    url: `/db/role/${id}`,
    method: 'delete'
  })
}

export function menuBindRequest(data) {
  return request({
    url: '/db/role/menu-bind',
    method: 'post',
    data
  })
}

export function addRequest(data) {
  return request({
    url: '/db/role',
    method: 'put',
    data
  })
}